import type { ReactNode } from 'react'

import * as styles from './input-box.styles'

type Props = {
  children: ReactNode
  startAdornment?: ReactNode
  endAdornment?: ReactNode
  focused: boolean
  hasError: boolean
}

export const InputBox = ({
  children,
  startAdornment = null,
  endAdornment = null,
  focused,
  hasError,
}: Props) => (
  <div
    css={(theme) => [
      styles.box(theme),
      focused && styles.focused(theme),
      hasError && styles.error(theme),
    ]}
  >
    {startAdornment}
    {children}
    {endAdornment}
  </div>
)
